export default "__VITE_ASSET__C3aEu24r__"